import TableCell from '@material-ui/core/TableCell/TableCell'
import TableRow from '@material-ui/core/TableRow/TableRow'
import {Fragment} from 'react'

interface IMobileRowProps {
  cells: {
    header: string|JSX.Element,
  value: string|JSX.Element
  }[]
}

const MobileRow = ({cells}: IMobileRowProps) => {
  return (
    <Fragment>
      {cells.map((cell, index) => (
        <TableRow key={index} className={'table-row'}>
          <TableCell className={'table-cell header-cell'}>
            {cell.header}
          </TableCell>
          <TableCell className={'table-cell'}>
            {cell.value}
          </TableCell>
        </TableRow>
      ))}
    </Fragment> 
  )
}

export default MobileRow
